import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import labels from "webforms/formio/_labels";
import FormSubmissionPrompt from "webforms/formio/formio-submission-prompt";
import formioController from "webforms/formio/formio.controller";

export default class FormioContainerController extends BasicAutoQueryController {
  constructor($scope) {
    super();
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.ngModel = this;
    $ctrl.labels = labels;
  }

  getQuery() {
    const $ctrl = this;
    return {
      url: `QueryFormSubmissions.json`,
      fields: "Id,Euid,Label,Description,Active,CreatedBy,CreatedOn,RefId",
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: {
        label: $ctrl.formioId,
      },
      filters: [],
      sortOptions: {},
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onSubmissionsLoaded(args),
    };
  }

  $delete(formConfig) {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Form")
      .result.then(function () {
        $ctrl.query.bus
          .send("DeleteFormSubmission.json", formConfig)
          .then(function (response) {
            $ctrl.query.load(true);
          });
      });
  }

  createSubmission(formioId = this.formioId) {
    const $ctrl = this;
    console.debug("createSubmission", { $ctrl, formioId });
    return FormSubmissionPrompt({
      formioId,
      title: `Create ${formioId} Submission...`,
    }).then(() => $ctrl.query.load(true));
  }

  edit(submission) {
    const $ctrl = this;
    console.debug("edit(submission", { $ctrl, submission });
    return FormSubmissionPrompt({
      formioId: submission.label,
      submissionId: submission.id,
      title: `Edit ${submission.label} Submission...`,
    }).then(() => $ctrl.query.load(true));
  }

  onSubmissionsLoaded(args) {}
}
